module.exports = __webpack_public_path__ + "static/media/community.9a0b5a7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/community.svg
// module id = 646
// module chunks = 36